import { render, staticRenderFns } from "./tanchuang2.vue?vue&type=template&id=0a2bf366&scoped=true&"
import script from "./tanchuang2.vue?vue&type=script&lang=js&"
export * from "./tanchuang2.vue?vue&type=script&lang=js&"
import style0 from "./tanchuang2.vue?vue&type=style&index=0&id=0a2bf366&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bf366",
  null
  
)

export default component.exports